import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import zh from './zh.json';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: en,
        },
        zh: {
            translation: zh,
        },
    },
    lng: 'en', // 默认语言
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false, // React 已经安全处理了转义
    },
});

export default i18n;
